import { CoreEvent, eventNames } from '@carvana/core-events';
import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import UserContext, {
  useIsLoggedIn,
  useUserLocation
} from '~/context/common/UserContext';
import useFavoritesFetcher from './useFavoritesFetcher';

export default function useGetFavorites() {
  const {
    favoriteChangeFlag,
    triggerEvent,
    favorites: { setLoaded, setData }
  } = useContext(UserContext);
  const fetchFavorites = useFavoritesFetcher();
  const { zip } = useUserLocation();
  const isLoggedIn = useIsLoggedIn();

  useEffectWithController(
    controller => {
      if (!isLoggedIn) {
        setLoaded();

        return;
      }

      if (!zip) return;

      function triggerFavoriteRemove() {
        triggerEvent.favoriteRemove();
      }

      function updateFavoritesData(payload) {
        if (payload.source === 'app' || !payload.vehicles) return;

        setData(payload.vehicles);
      }

      void fetchFavorites(zip, controller);

      CoreEvent.on(eventNames.favorites.vehicle.removed, triggerFavoriteRemove);
      CoreEvent.on(eventNames.favorites.mfe.refresh, updateFavoritesData);

      return () => {
        CoreEvent.off(
          eventNames.favorites.vehicle.removed,
          triggerFavoriteRemove
        );
        CoreEvent.off(eventNames.favorites.mfe.refresh, updateFavoritesData);
      };
    },
    [
      favoriteChangeFlag,
      fetchFavorites,
      isLoggedIn,
      setData,
      setLoaded,
      triggerEvent,
      zip
    ]
  );
}
